import { Indicator } from '../../../Common/Charts/Indicator';
import { useVaccinationChartsDataContext } from './hooks/useVaccinationChartsDataContext';

export const VaccinatedKidsUnderOneYearWithHB = () => {
    const { chartData } = useVaccinationChartsDataContext();

    return (
        <Indicator
            title={'Crianças de 1 ano vacinadas com vacina Hepatite B'}
            indicatorValue={chartData?.indicators?.vaccinatedKidsUnderOneYearWithHB}
        />
    );
};
